import { useSearchParams } from 'react-router-dom';
import FormStep1Container from 'containers/FormStep1Container';
import FormStep4Container from 'containers/FormStep4Container';
import WrapperForm2Section1to3 from 'containers/WrapperForm2Section1to3';
import WrapperForm3Section1to2 from 'containers/WrapperForm3Section1to2';

export default function MiddleSectionRegisterPage() {
  const [searchParams] = useSearchParams();

  const stepMap = {
    '1': FormStep1Container,
    '2': WrapperForm2Section1to3,
    '3': WrapperForm3Section1to2,
    '4': FormStep4Container
  };

  const step = searchParams.get('step') || '1';

  const Component = stepMap[step[0] as keyof typeof stepMap];

  if (!Component) return <></>;

  return <Component />;
}
